module.exports = __webpack_public_path__ + "5217cbc3b14b1f23840ff219f23820a9.svg";